import React, { useState } from "react";
import { NavLink } from 'react-router-dom';
import { IoClose } from "react-icons/io5";

import '../../CustomAssets/Css/Components/Sidebar.css';
export default function Sidebar({ isOpen, setIsOpen }) {

    const closeMenu = () => {
        setIsOpen(!isOpen);
    }

    return (
        <>
            <div className={`offcanvas offcanvas-end CustomVisibility ${isOpen ? 'sidebarShow' : ''}`} id="offcanvasRight">
                <div className="offcanvas-body custom-nevbar org_clr customSidebar">
                    <div className="row">
                        <div className="">
                            <div className="custom-nevbar__left custom_p">


                                <div className="sidebarHeading">

                                    <div>
                                        <span className="main_logo_text">LOANSMONEY</span>
                                    </div>

                                    <button type="button" className="sidebarCloseIcon iconColor" data-bs-dismiss="offcanvas"
                                        aria-label="Close" onClick={closeMenu}>
                                        <span> <IoClose /> </span>
                                    </button>

                                </div>


                                <div>
                                    <ul id="menu-main-menu-1" className="navbar-nav mb-lg-0">
                                        <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2818 nav-item">
                                            <NavLink to={"/"} className="nav-item">Home</NavLink>
                                        </li>

                                        <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2818 nav-item">
                                            <NavLink to={"/aboutUs"} className="nav-item">About</NavLink>
                                        </li>

                                        <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2818 nav-item">
                                            <NavLink to={"/services"} className="nav-item">Services</NavLink>
                                        </li>
                                        
                                        <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2818 nav-item">
                                            <NavLink to={"/plans"} className="nav-item">Plans</NavLink>
                                        </li>

                                        <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2818 nav-item">
                                            <NavLink to={"/careers"} className="nav-item">Career</NavLink>
                                        </li>

                                        <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2818 nav-item">
                                            <NavLink to={"/contactUs"} className="nav-item">Contact Us</NavLink>
                                        </li>

                                        <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2818 nav-item" onClick={() => window.location.href = "https://loansmoney.in/partnerPanel/"}>
                                            <NavLink className="nav-item">Sign In</NavLink>
                                        </li>

                                    </ul>
                                </div>

                            </div>
                        </div>

                        <div className="">
                            <div className="custom-nevbar__left custom_p">

                                <div>
                                    <ul id="menu-main-menu-1" className="navbar-nav mb-lg-0 sideBarContact">
                                        <li>
                                            <p className="mb-2"> Call: </p>
                                            <span>9749892861</span>
                                        </li>
                                        <li>
                                            <p className="mb-2"> Email: </p>
                                            <span>Support@loansmoney.in</span>
                                        </li>
                                        <li>
                                            <p className="mb-2"> Location: </p>
                                            <span>kolkata, New Town</span>
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}
